import * as Actions from '../constant/ActionTypes';

const listPlacedCamPositionsReducer = (placedCameras=[], action) => {
    switch(action.type) {
        case Actions.LIST_PLACED_CAM_POSITIONS:
            return action.payload;
            
        default :
        return placedCameras;
    }
}
export default listPlacedCamPositionsReducer;